import { ProjectType } from '@aviv-search/types';
export var ProjectTypeLegacyId;
(function (ProjectTypeLegacyId) {
    ProjectTypeLegacyId[ProjectTypeLegacyId["RESALE"] = 1] = "RESALE";
    ProjectTypeLegacyId[ProjectTypeLegacyId["NEW"] = 2] = "NEW";
    // N/A Luxe = 3,
    ProjectTypeLegacyId[ProjectTypeLegacyId["PROJECT"] = 4] = "PROJECT";
})(ProjectTypeLegacyId || (ProjectTypeLegacyId = {}));
const defaultLegacyProjectType = ProjectTypeLegacyId.RESALE;
export const getProjectTypeLegacy = (searchModel) => {
    if (!searchModel?.projectTypes)
        return defaultLegacyProjectType;
    const { projectTypes } = searchModel;
    if (projectTypes.includes(ProjectType.NEW_BUILD))
        return ProjectTypeLegacyId.NEW;
    if (projectTypes.includes(ProjectType.PROJECTED))
        return ProjectTypeLegacyId.PROJECT;
    // default
    return defaultLegacyProjectType;
};
